
import React, {Component} from 'react';
import {
  Link
} from 'react-router-dom'

import './subscription-title.css'

/**
 * @author chargoyao
 * @property {string} linkName link name
 * @property {string} crumb
 * @property {string} btnText button text
 * @property {string} btnClassName button class name
 * @property {function} handleDownload download callback
 */
class SubscriptionInfoTitle extends Component {
  handleDownload () {
    this.props.handleDownload()
  }
  render () {
    return (
      <div className="subscription-info-title clearfix">
        <ul className="clearfix">
          <li>
            <Link to="/dashboard">{ this.props.linkName }</Link>
          </li>
          <li>
            >
          </li>
          <li>
            { this.props.crumb }
          </li>
        </ul>
        <button className={this.props.btnClassName} onClick={() => this.handleDownload()}>
          { this.props.btnText }
        </button>
      </div>
    )
  }
}

SubscriptionInfoTitle.defaultProps = {
  linkName: 'Dashboard',
  crumb: 'Subscriptions',
  btnText: 'DOWNLOAD CSV FILE'
}

export default SubscriptionInfoTitle;


// WEBPACK FOOTER //
// ./src/components/SubscriptionsInfo/Title/Title.jsx